// Period-over-period change for a count, computed client-side from the
// current/previous pair the dashboard endpoints return.
//
//   previous 0, current > 0  -> { type: "new" }      (shown as "New", never 100%)
//   previous 0, current 0    -> { type: "none" }     (nothing to compare)
//   otherwise                -> { type: "change", value } rounded whole percent
//   missing numbers          -> null (no badge)
export function percentChange(current, previous) {
  if (!Number.isFinite(current) || !Number.isFinite(previous)) return null;
  if (previous === 0) {
    return current === 0 ? { type: "none" } : { type: "new" };
  }
  const value = Math.round(((current - previous) / Math.abs(previous)) * 100);
  return { type: "change", value: Object.is(value, -0) ? 0 : value };
}

// Difference between two values of the same unit (rates, days, counts), used
// where a percent of a percent would mislead: 0.51 -> 0.54 is "3 pts", not 6%.
export function absoluteChange(current, previous) {
  if (!Number.isFinite(current) || !Number.isFinite(previous)) return null;
  return current - previous;
}
